import React from 'react'

function ReportedIssues() {
    return (
        <div>ReportedIssues</div>
    )
}

export default ReportedIssues